import _objectSpread from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { getDict as _getDict } from "@/utils/dictionary";
export default {
  data: function data() {
    return {
      page: 1,
      total: 10,
      pageSize: 10,
      tableData: [],
      searchInfo: {},
      qData: {}
    };
  },
  methods: {
    filterDict: function filterDict(value, type) {
      var rowLabel = this[type + "Options"] && this[type + "Options"].filter(function (item) {
        return item.value == value;
      });
      return rowLabel && rowLabel[0] && rowLabel[0].label;
    },
    getDict: function getDict(type) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var dicts;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _getDict(type);
            case 2:
              dicts = _context.sent;
              _this[type + "Options"] = dicts;
              return _context.abrupt("return", dicts);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
    },
    getTableData: function getTableData() {
      var _arguments = arguments,
        _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var page, pageSize, listAlias, table;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : _this2.page;
              pageSize = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : _this2.pageSize;
              listAlias = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : _this2.listAlias;
              if (page == 0) {
                page = 1;
              }
              _context2.next = 6;
              return _this2.listApi(_objectSpread({
                page: page,
                pageSize: pageSize
              }, _this2.searchInfo));
            case 6:
              table = _context2.sent;
              if (table.code == 0) {
                if (!listAlias) {
                  listAlias = 'list';
                }
                _this2.tableData = table.data[listAlias];
                _this2.total = table.data.total < 0 ? 0 : table.data.total;
                _this2.page = table.data.page;
                _this2.pageSize = table.data.pageSize;
                _this2.qData = table.data;
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};